import type { CardViewModel } from '@pesto/features/src/Cards/types/Cards.types';

import { UserCardsPanel } from '@pesto/features/src/Cards/components/UserCardsPanel';
import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { routes } from '../../../constants/routes';

interface LoanCardsTabProps {
  cards: CardViewModel[];
}

export const LoanCardsTab = ({ cards }: LoanCardsTabProps) => {
  const navigate = useNavigate();

  return (
    <UserCardsPanel
      cards={cards}
      onCardClick={(card) => navigate(routes.cards + '/' + card.id)}
      onUserClick={(userId) => navigate(routes.users + '/' + userId)}
      emptyState={<EntityEmptyState icon={CreditCard} title="This loan has no cards on file." />}
    />
  );
};
